import React from 'react';
import styled from '@emotion/styled';
import RuleStore from '../RulesDetails/stores';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { useAppSelector } from 'src/utils/Hooks/typedHooks';

interface RuleSummaryItemProps {
  ruleName: string;
  ruleId: string;
}

const RuleDiv = styled.div`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const RuleSummaryItem: React.FC<RuleSummaryItemProps> = ({ ruleName, ruleId }) => {
  const { setEditRuleId, setRuleName } = RuleStore((s) => ({
    setEditRuleId: s.setEditRuleId,
    setRuleName: s.setRuleName
  }));
  const { beaconNavigator } = useBeaconNavigator();
  const hashId = useAppSelector((state) => state.user?.config?.vendor?.hashId);

  return (
    <RuleDiv
      role="button"
      onClick={() => {
        setEditRuleId(ruleId);
        setRuleName(ruleName);
        beaconNavigator.setPathname(`client/${hashId}`);
        beaconNavigator.updateSearchParams({ tab: 'advertising', subtab: 'rulesDetails' });
        beaconNavigator.go();
      }}
    >
      {ruleName}
    </RuleDiv>
  );
};
